import { render, staticRenderFns } from "./TechnicalExchange.vue?vue&type=template&id=076126db&scoped=true"
import script from "./TechnicalExchange.vue?vue&type=script&lang=js"
export * from "./TechnicalExchange.vue?vue&type=script&lang=js"
import style0 from "./TechnicalExchange.vue?vue&type=style&index=0&id=076126db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076126db",
  null
  
)

export default component.exports